<template>
    <div class="Estante">
        <Header></Header>

        <div class="container mt-4" v-if="treinamento">
            <div class="row" v-if="treinamento">
                <div class="col-12 col-md-4 col-lg-3">
                    <div class="dados-curso pb-2">
                        <div class="img-curso">
                            <img class="img-fluid" :src="(treinamento.urlImagemCapa==null?'img-default-curso.png':treinamento.urlImagemCapa)" onerror="this.onerror=null; this.src='/img-default-curso.png'" />
                            <div class="avaliacao d-flex flex-column py-2 px-3 justify-content-center" v-if="avaliacao">
                                <p class="txt-p txt-w-5 txt-size-10 txt-blue-3 mb-1">
                                    Avaliação média dos usuários:
                                </p>
                                <Estrelas :nota="avaliacao.nota" :qtdAvaliacoes="avaliacao.qtdAvaliacoes"></Estrelas>
                            </div>
                        </div>
                        <div class="d-flex justify-content-evenly" style="background: #F2F2F2 ">
                            <div class="d-flex py-3 align-items-center me-3">
                                <i class="txt-grey-5 fa-solid fa-book-bookmark txt-size-30"></i>
                                <div class="d-flex flex-column ms-2">
                                    <p class="txt-p txt-w-7 txt-size-10 txt-grey-3 mb-0">
                                        Categoria
                                    </p>
                                    <p class="txt-p txt-w-4 txt-size-10 txt-grey-3 mb-0">
                                        {{treinamento.nmCategoria}}
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex py-3 align-items-center">
                                <i class="txt-grey-5 fa-regular fa-clock txt-size-30"></i>
                                <div class="d-flex flex-column ms-2">
                                    <p class="txt-p txt-w-7 txt-size-10 txt-grey-3 mb-0">
                                        Duração
                                    </p>
                                    <p class="txt-p txt-w-4 txt-size-10 txt-grey-3 mb-0">
                                        {{treinamento.duracaoTreinamento}} Horas
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div class="d-flex justify-content-evenly bg-grey-1">
                            <div class="d-flex py-3 align-items-center me-3">
                                <div class="d-flex flex-column ms-2">
                                    <p class="txt-p txt-w-7 txt-size-20 txt-blue-3 mb-0">
                                        <span class="txt-size-14">R$</span> {{moeda()}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-3">
                            <div class="mb-3" v-if="treinamento.dtTreinamento">
                                <p class="txt-p txt-w-4 txt-size-16 txt-grey-3 mb-1 text-center">
                                    <i class="txt-w-7 far fa-calendar"></i> {{treinamento.dtTreinamento}}
                                </p>
                            </div>
                            <div class="mb-3" v-if="lstTemas.length > 0">
                                <p class="txt-p txt-w-7 txt-size-16 txt-grey-3 mb-1">Temas</p>
                                <ul class="txt-p txt-w-4 txt-size-16 txt-grey-3">
                                    <li v-for="(item,index) in lstTemas" :key="index">
                                        {{item.nmTema}}
                                    </li>
                                </ul>
                            </div>
                            <div class="mb-3" v-if="lstMinistrantes.length > 0">
                                <p class="txt-p txt-w-7 txt-size-16 txt-grey-3 mb-1">Ministrantes</p>
                                <ul class="txt-p txt-w-4 txt-size-16 txt-grey-3">
                                    <li v-for="(item,index) in lstMinistrantes" :key="index">
                                        {{item.dsMinistrante}}
                                    </li>
                                </ul>
                            </div>
                            <div class="mb-3">
                                <p class="txt-p txt-w-5 txt-size-16 txt-grey-3 mb-1">Características do curso:</p>
                                <ul class="txt-p txt-w-4 txt-size-16 txt-grey-3">
                                    <li v-if="lstAulas && lstAulas.length > 0">
                                        {{lstAulas.length}} Aulas em vídeo
                                    </li>
                                    <li v-if="lstMateriais && lstMateriais.length > 0">
                                        {{lstMateriais.length}} Textos e artigos
                                    </li>
                                    <li>
                                        Acesso imediato a todo conteúdo
                                    </li>
                                </ul>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="col-12 col-md-8 col-lg-9">
                    <div class="mt-3">
                        <p class="txt-p txt-w-7 txt-size-25 txt-blue-3 mb-3">
                            {{treinamento.nmTreinamento}}
                        </p>
                        <p class="txt-p txt-w-5 txt-size-16 txt-grey-3 mb-4">
                            {{treinamento.dsTreinamento}}
                        </p>
                    </div>
                    <div class="" v-if="lstConteudos.length > 0">
                        <span class="txt-p txt-w-7 txt-size-20 txt-blue-3">
                            Assuntos abordados no curso
                        </span>
                        <ul class="mt-3 txt-p txt-size-16 txt-grey-3 txt-w-4">
                            <li class="mb-2" v-for="(item,index) in lstConteudos" :key="index">
                                {{item.dsConteudo}}
                            </li>
                        </ul>

                    </div>
                    <div>
                        <template v-if="jaComprado">
                            <router-link class="btn bg-cores-3 txt-white" :to="{name:'Assistir', params:{id:id}}" v-if="flAtivo">
                                Assistir
                            </router-link>
                            <button class="btn bg-cores-3 txt-white" @click="reativar" v-else>
                                Reativar
                            </button>
                        </template>
                        <template v-else>
                            <template v-if="treinamento.flGratis">
                                <div class="d-grid">
                                    <button class="btn bg-cores-3 txt-white" type="button" @click="inscrever" v-if="user">
                                        Adicionar este curso a minha biblioteca de cursos
                                    </button>
                                    <button class="btn bg-cores-3 txt-white" type="button" v-else @click="showModalCadastro = !showModalCadastro">
                                        Cadastre-se para se inscrever
                                    </button>
                                </div>
                            </template>
                            <template v-else>
                                <div class="d-grid">
                                    <button class="btn bg-cores-3 txt-white" type="button" @click="comprar" v-if="!noCarrinho">
                                        Comprar
                                    </button>
                                    <button class="btn bg-cores-3 txt-white" type="button" @click="avisoCarrinho" v-else>
                                        <i class="fas fa-cart-arrow-down"></i>
                                    </button>
                                </div>
                            </template>
                        </template>

                    </div>
                </div>

            </div>
        </div>

        <b-modal ref="modal-resultado-compra" id="modalResultadoCompra" size="md" centered :hide-footer="true" :hide-header="true">
            <!--<div class="w-100 text-end txt-size-20 txt-blue-2">
            <span @click="close"><i class="fas fa-times c-pointer"></i></span>
        </div>-->
            <div class="p-3">
                <div class="row">
                    <div class="col-1">
                        <p class="txt-p txt-size-25 txt-w-7 txt-cores-3">
                            <i class="fa-solid fa-check"></i>
                        </p>
                    </div>
                    <div class="col-11">
                        <p class="txt-p txt-size-25 txt-w-7 txt-cores-3">
                            Curso adicionado com sucesso!
                        </p>
                        <p class="txt-p txt-size-20 txt-w-5 txt-grey-3">
                            Este curso foi adicionado a sua biblioteca de cursos.
                        </p>
                        <p class="txt-p txt-size-16 txt-w-5 txt-grey-3">
                            Para acessa-lo, basta ir até o menu <span class="txt-w-7">Meus Cursos</span>.
                        </p>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <router-link class="btn bg-blue-5 txt-white" :to="{name:'MeusCursos'}">
                                    Ir para Meus Cursos
                                </router-link>
                            </div>
                            <div class="col-12 col-md-6">
                                <router-link :to="{name:'Estante'}" class="txt-p txt-size-14 txt-w-5 txt-blue-5 c-pointer">
                                    Continuar navegando na Estante de Cursos
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </b-modal>

        <ModalCadastro  :showModal="showModalCadastro"></ModalCadastro>

        <Footer class="mt-5"></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Estrelas from '@/components/Estrelas'
    import ModalCadastro from '@/components/ModalCadastro'

    import { urlApi, avisoErro, numeroParaMoeda, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Curso',
        components: { Header, Footer, Estrelas, ModalCadastro },
        props: ['id'],
        data: function () {
            return {
                treinamento: null,
                categoria: null,
                lstAulas: [],
                lstConteudos: [],
                lstMateriais: [],
                lstMinistrantes: [],
                lstTemas: [],
                jaComprado: false,
                flAtivo: false,
                noCarrinho: false,
                usuarioTreinamento: null,
                showModalCadastro: false,

                avaliacao: null,
                
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        
        methods: {
            
            load() {
                if (this.user) {
                    this.possuiTreinamento();
                }
                
                
                this.getCurso();
            },

            showModal() {
                this.$refs['modal-resultado-compra'].show();
            },
            hideModal() {
                this.$refs['modal-resultado-compra'].show();
            },

            possuiTreinamento() {
                let $this = this;
                axios.get(`${urlApi}/UsuarioTreinamento/PossuiTreinamento/${$this.id}`)
                    .then(res => {
                        if (res.data.success) {
                            $this.usuarioTreinamento = res.data.data;
                            $this.jaComprado = res.data.data.idUsuarioTreinamento != null && res.data.data.idUsuarioTreinamento > 0 ? true : false;
                            $this.flAtivo = res.data.data.flAtivo;
                        } else {
                            avisoErro("Não foi possível verificar o curso");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível verificar o curso");
                    });
            },

            getCurso() {
                let $this = this;
                axios.get(`${urlApi}/Treinamento/Get/${$this.id}`)
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data != null) {
                                $this.treinamento = res.data.data.treinamento;
                                $this.categoria = res.data.data.categoria;
                                $this.treinamento.nrNota = 5;

                                if ($this.treinamento.dtTreinamento) {
                                    $this.treinamento.dtTreinamento = moment($this.treinamento.dtTreinamento).format('DD/MM/YYYY');
                                }
                                
                                $this.treinamento.duracaoTreinamento = ($this.treinamento.duracaoTreinamento == null ? 0 : Math.ceil($this.treinamento.duracaoTreinamento / 3600));

                                $this.avaliacao = {
                                    nota: res.data.data.avaliacao.nota,
                                    qtdAvaliacoes: res.data.data.avaliacao.qtdAvaliacoes,
                                };

                                $this.getAulas();
                                $this.getConteudos();
                                $this.getMateriais();
                                $this.getMinistrantes();
                                $this.getTemas();

                                if (!$this.treinamento.flGratis) {
                                    $this.noCarrinho = ($this.$store.state.carrinho.find(element => element.idTreinamento == $this.treinamento.idTreinamento) == undefined ? false : true);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar o curso");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar o curso");
                    });
            },

            getAulas() {
                let $this = this;
                axios.get(`${urlApi}/TreinamentoAula/Get`, { params: { idTreinamento: $this.id } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.lstAulas = [];
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i];

                                    $this.lstAulas.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar as aulas");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar as aulas");
                    });
            },

            getConteudos() {
                let $this = this;
                axios.get(`${urlApi}/TreinamentoConteudo/Get`, { params: { idTreinamento: $this.id } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.lstConteudos = [];
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i];

                                    $this.lstConteudos.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os conteudos");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os conteudos");
                    });
            },

            getMateriais() {
                let $this = this;
                axios.get(`${urlApi}/TreinamentoMaterial/Get`, { params: { idTreinamento: $this.id } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.lstMateriais = [];
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i];

                                    $this.lstMateriais.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os materiais");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os materiais");
                    });
            },

            getMinistrantes() {
                let $this = this;
                axios.get(`${urlApi}/Treinamento/GetMinistrantes/${$this.id}`)
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.lstMinistrantes = [];
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i];

                                    $this.lstMinistrantes.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os conteudos");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os conteudos");
                    });
            },

            getTemas() {
                let $this = this;
                axios.get(`${urlApi}/Tema/Get`, { params: { idTreinamento: $this.id } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.lstTemas = [];
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i];

                                    $this.lstTemas.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os temas");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os temas");
                    });
            },
           
            inscrever() {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamento/Inscrever`, { idTreinamento: $this.id })
                    .then(res => {
                        if (res.data.success) {
                            $this.jaComprado = true;
                            $this.showModal();
                        } else {
                            avisoErro("Não foi possível realizar a inscrição");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível realizar a inscrição");
                    });
            },

            moeda() {
                return numeroParaMoeda(this.treinamento.vlTreinamento);
            },

            comprar() {
                let $this = this;
                var carrinho = $this.$store.state.carrinho;
                if (!carrinho) {
                    carrinho = [];
                }
                carrinho.push($this.treinamento);
                $this.$store.commit('setCarrinho', carrinho);
                $this.$router.push({ name: 'Carrinho' });
            },


            avisoCarrinho() {
                avisoToast("Este curso já foi adicionado no carrinho", "warning");
            },

            reativar() {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamento/Reativar`, { idUsuarioTreinamento: $this.usuarioTreinamento.idUsuarioTreinamento })
                    .then(function () {
                        $this.$router.push({ name: 'MeusCursos' });
                    })
                    .catch(function () {
                        avisoErro("Não foi possível reativar o curso");
                    });
            },
        },
        created: function () {
            this.load();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .dados-curso {
        background: #FFFFFF;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
        border-radius: 10px;

        .img-curso {
            position: relative;
            display: flex;
            justify-content: center;
            /*background-color: #F2F2F2;*/

            img {
                width: 100%;
                /*height: 391px;*/
                height: auto;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                border-radius: 10px 10px 0 0;
            }

            .avaliacao {
                position: absolute;
                bottom: 0;
                background: #FFFFFF;
                box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
                border-radius: 10px 10px 0 0;
            }
        }
    }

</style>

